module.exports = __webpack_public_path__ + "static/media/slider-bg.43e62df6.jpg";